import React, { useState } from 'react';

const FilterBar = ({ onFilter }) => {
  const [filters, setFilters] = useState({
    specialty: '',
    cell: '',
    month: '',
    dateFilter: '',
    dayOfWeek: '',
    weekRange: '',
    dateRange: { start: '', end: '' },
    sortBy: 'name',
    sortOrder: 'asc'
  });
  const [customSpecialty, setCustomSpecialty] = useState('');
  const [showCustomSpecialtyInput, setShowCustomSpecialtyInput] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'specialty' && value === 'custom') {
      setShowCustomSpecialtyInput(true);
      setFilters(prev => ({ ...prev, specialty: '' }));
    } else if (name === 'weekRange' && value) {
      setShowCustomSpecialtyInput(false);
      setCustomSpecialty('');
      const weekRange = getWeekRange(parseInt(value));
      const newFilters = {
        ...filters,
        [name]: value,
        dateRange: weekRange
      };
      setFilters(newFilters);
      onFilter(newFilters);
    } else {
      setShowCustomSpecialtyInput(false);
      setCustomSpecialty('');
      const newFilters = {
        ...filters,
        [name]: value
      };
      setFilters(newFilters);
      onFilter(newFilters);
    }
  };

  const handleCustomSpecialtyChange = (e) => {
    setCustomSpecialty(e.target.value);
    const newFilters = {
      ...filters,
      specialty: e.target.value
    };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  const handleDateRangeChange = (e) => {
    const { name, value } = e.target;
    const newDateRange = {
      ...filters.dateRange,
      [name]: value
    };
    const newFilters = {
      ...filters,
      dateRange: newDateRange,
      weekRange: ''
    };
    setFilters(newFilters);
    onFilter(newFilters);
  };

  const getWeekRange = (weekOffset = 0) => {
    const today = new Date();
    const currentDay = today.getDay();
    const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1) + (weekOffset * 7);
    const monday = new Date(today.setDate(diff));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    
    return {
      start: monday.toISOString().split('T')[0],
      end: sunday.toISOString().split('T')[0]
    };
  };

  const specialties = [
    'Medicina General', 'Cardiología', 'Dermatología', 'Endocrinología',
    'Gastroenterología', 'Ginecología y Obstetricia', 'Neurología', 'Oncología',
    'Oftalmología', 'Ortopedia y Traumatología', 'Otorrinolaringología', 'Pediatría',
    'Psiquiatría', 'Psicología', 'Reumatología', 'Urología', 'Neumología',
    'Cirugía General', 'Cirugía Laparoscópica', 'Cirugía Plástica y Reconstructiva',
    'Cirugía Cardiovascular', 'Cirugía Pediátrica', 'Cirugía Oncológica',
    'Cirugía Coloproctológica', 'Cirugía Maxilofacial', 'Medicina Interna',
    'Nefrología', 'Hematología', 'Medicina Física y Rehabilitación',
    'Anestesiología', 'Medicina Familiar', 'Infectología', 'Radiología',
    'Endodoncia (odontología especializada)', 'Odontología (Dentista)',
    'Nutriología', 'Terapia Física', 'Medicina del Deporte', 'Toxicología',
    'Genética Médica', 'Fisioterapia', 'Terapia Ocupacional',
    'Logopedia (Terapia del lenguaje)'
  ];

  const cells = [
    '', 'C1GA', 'C2GA', 'C3GA', 'C4GA', 'C5GA', 'C6GA',
    'C1MA', 'C2MA', 'C3MA', 'C4MA',
    'G1M1', 'G1M2', 'G1M3', 'G1M4', 'G2M1', 'G2M2', 'G2M3', 'G2M4',
    'G3M1', 'G3M2', 'G3M3', 'G3M4', 'G4M1', 'G4M2', 'G4M3', 'G4M4',
    'G5M1', 'G5M2', 'G5M3', 'G5M4', 'G6M1', 'G6M2', 'G6M3', 'G6M4'
  ];

  const months = [
    { value: '', label: 'Todos los meses' },
    { value: '1', label: 'Enero' }, { value: '2', label: 'Febrero' },
    { value: '3', label: 'Marzo' }, { value: '4', label: 'Abril' },
    { value: '5', label: 'Mayo' }, { value: '6', label: 'Junio' },
    { value: '7', label: 'Julio' }, { value: '8', label: 'Agosto' },
    { value: '9', label: 'Septiembre' }, { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' }, { value: '12', label: 'Diciembre' }
  ];

  const daysOfWeek = [
    { value: '', label: 'Todos los días' },
    { value: '1', label: 'Lunes' }, { value: '2', label: 'Martes' },
    { value: '3', label: 'Miércoles' }, { value: '4', label: 'Jueves' },
    { value: '5', label: 'Viernes' }, { value: '6', label: 'Sábado' },
    { value: '0', label: 'Domingo' }
  ];

  const weekRanges = [
    { value: '', label: 'Seleccionar semana' },
    { value: '0', label: 'Esta semana' },
    { value: '-1', label: 'Semana pasada' },
    { value: '1', label: 'Próxima semana' },
    { value: '-2', label: 'Hace 2 semanas' },
    { value: '2', label: 'En 2 semanas' }
  ];

  const resetFilters = () => {
    const resetFilters = {
      specialty: '',
      cell: '',
      month: '',
      dateFilter: '',
      dayOfWeek: '',
      weekRange: '',
      dateRange: { start: '', end: '' },
      sortBy: 'name',
      sortOrder: 'asc'
    };
    setFilters(resetFilters);
    setCustomSpecialty('');
    setShowCustomSpecialtyInput(false);
    onFilter(resetFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 space-y-6 border-l-4 border-[#0061A8]">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-[#0061A8] flex items-center">
          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.414A1 1 0 013 6.707V4z" />
          </svg>
          Filtros de Búsqueda
        </h3>
        <button
          onClick={resetFilters}
          className="flex items-center text-sm text-[#63666A] hover:text-[#0061A8] py-2 px-4 rounded-md transition-colors border border-[#D1D3D4] hover:border-[#0061A8]"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Limpiar Filtros
        </button>
      </div>

      {/* Filtros Básicos */}
      <div>
        <h4 className="text-sm font-medium text-[#63666A] mb-3 uppercase tracking-wide border-b border-[#D1D3D4] pb-2">
          Filtros Básicos
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
              Especialidad
            </label>
            <select
              name="specialty"
              value={showCustomSpecialtyInput ? 'custom' : filters.specialty}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              <option value="">Todas las especialidades</option>
              {specialties.map(spec => (
                <option key={spec} value={spec}>{spec}</option>
              ))}
              <option value="custom">Otra (especificar)</option>
            </select>
            {showCustomSpecialtyInput && (
              <input
                type="text"
                value={customSpecialty}
                onChange={handleCustomSpecialtyChange}
                placeholder="Especifique especialidad"
                className="mt-2 w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
              />
            )}
          </div>

          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Célula
            </label>
            <select
              name="cell"
              value={filters.cell}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              {cells.map(cell => (
                <option key={cell} value={cell}>{cell === '' ? 'Todas las células' : cell}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Mes
            </label>
            <select
              name="month"
              value={filters.month}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              {months.map(month => (
                <option key={month.value} value={month.value}>{month.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Filtros por Fecha */}
      <div>
        <h4 className="text-sm font-medium text-[#63666A] mb-3 uppercase tracking-wide border-b border-[#D1D3D4] pb-2">
          Filtros por Fecha
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Fecha Específica
            </label>
            <input
              type="date"
              name="dateFilter"
              value={filters.dateFilter}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            />
          </div>

          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Día de la Semana
            </label>
            <select
              name="dayOfWeek"
              value={filters.dayOfWeek}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              {daysOfWeek.map(day => (
                <option key={day.value} value={day.value}>{day.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              Semana
            </label>
            <select
              name="weekRange"
              value={filters.weekRange}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              {weekRanges.map(week => (
                <option key={week.value} value={week.value}>{week.label}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Rango Personalizado
            </label>
            <div className="space-y-2">
              <input
                type="date"
                name="start"
                value={filters.dateRange.start}
                onChange={handleDateRangeChange}
                placeholder="Desde"
                className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors text-xs"
              />
              <input
                type="date"
                name="end"
                value={filters.dateRange.end}
                onChange={handleDateRangeChange}
                placeholder="Hasta"
                className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors text-xs"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Ordenamiento */}
      <div>
        <h4 className="text-sm font-medium text-[#63666A] mb-3 uppercase tracking-wide border-b border-[#D1D3D4] pb-2">
          Ordenamiento
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
              </svg>
              Ordenar por
            </label>
            <select
              name="sortBy"
              value={filters.sortBy}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              <option value="name">Nombre</option>
              <option value="specialty">Especialidad</option>
              <option value="conversion">Tasa de conversión</option>
              <option value="date">Fecha de última junta</option>
            </select>
          </div>

          <div>
            <label className="flex items-center text-sm font-medium text-[#63666A] mb-2">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
              </svg>
              Orden
            </label>
            <select
              name="sortOrder"
              value={filters.sortOrder}
              onChange={handleChange}
              className="w-full border border-[#D1D3D4] rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#0061A8] focus:border-[#0061A8] transition-colors"
            >
              <option value="asc">Ascendente (A-Z, menor a mayor)</option>
              <option value="desc">Descendente (Z-A, mayor a menor)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
